/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useEffect, useRef, useState, forwardRef, useContext } from "react";
import "./Toolbar.css";
import "./Tooltip.css";
import { Icon } from "./styles.jsx";
import { RxBorderWidth, RxCaretDown, RxCross1, RxDownload, RxImage, RxKeyboard } from "react-icons/rx";
import { MdCloseFullscreen, MdOpenInFull, MdOutlineBrush } from "react-icons/md";
import { getHTML } from "./htmlParser.jsx";
import { saveAs } from "file-saver";
import { trackPromise } from "react-promise-tracker";
import { inputValidation } from "./utils";
import ClickAway from "./ClickAway.jsx";
import store from "./store.js";
import idb from "./idb.js";
import ModalApp from "./ModalApp";
import API from "../../api/api/API";
import moment from "moment";
import zoomInIcon from "./images/toolbarButton-zoomIn.svg";
import zoomOutIcon from "./images/toolbarButton-zoomOut.svg";
// import GlobalContext from "@/components/GlobalContext";
import { Button } from "../CommonComponents.js";
const scaleOptions = [
  { label: "25%", value: 0.25 },
  { label: "50%", value: 0.5 },
  { label: "75%", value: 0.75 },
  { label: "100%", value: 1 },
  { label: "200%", value: 2 },
  { label: "300%", value: 3 },
  { label: "400%", value: 4 },
  { label: "500%", value: 5 },
  { label: "600%", value: 6 },
  { label: "700%", value: 7 },
  { label: "800%", value: 8 },
];

const ColorPicker = forwardRef(function ColorPicker(props, ref) {
  return (
    <input
      ref={ref}
      // hidden
      style={{ width: 0, visibility: "hidden" }}
      type="color"
      name=""
      id=""
      value={props.color}
      onChange={(e) => {
        props.onChange(e.target.value);
      }}
    />
  );
});

function ImageEditToolbar(props) {
  const colorRef = useRef(null);
  const key = props._key;
  const brush = props.brush;

  function onSelect() {
    colorRef.current.click();
  }

  function onSetColor(color) {
    props.onColorSelect(color);
  }
  const brushSizes = [2, 3, 5, 8, 13, 21, 34];

  const [showBrushSizes, setShowBrushSizes] = useState(false);
  const [selectedBrushSize, setSelectedBrushSize] = useState(brushSizes[3]);

  return (
    <div className="flex-row" style={{ gap: 20, padding: 3 }}>
      <div className="tooltipbar--drop-select--main-cont">
        <div className="tooltipbar--drop-select-cont">
          <ColorPicker ref={colorRef} color={brush.color} onChange={onSetColor} />
          <div className="tooltipbar--drop-select" onClick={props.onBrushSelect} active={brush.active.toString()}>
            <MdOutlineBrush />
            <div className="color-disp--rect" style={{ background: brush.color }} />
          </div>

          <div className="flex-row" onClick={onSelect}>
            <RxCaretDown />
          </div>
        </div>
      </div>

      <div className="tooltipbar--drop-select--main-cont">
        <ClickAway onClickAway={setShowBrushSizes} sync={showBrushSizes}>
          <div className="tooltipbar--drop-select-cont" onClick={() => setShowBrushSizes(!showBrushSizes)}>
            <div className="tooltipbar--drop-select">
              <RxBorderWidth />
            </div>

            <div className="flex-row">
              <RxCaretDown />
            </div>
          </div>
          <div
            className="color-picker--cont"
            style={{
              display: showBrushSizes ? "flex" : "none",
              flexDirection: "column",
              gap: 2,
              padding: 2.6,
              background: "#f7f7f7",
            }}
          >
            {brushSizes.map((c, idx) => (
              <Icon
                key={idx}
                active={selectedBrushSize === c}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 2.6,
                  width: 126,
                }}
                onClick={() => {
                  setSelectedBrushSize(c);
                  props.onBrushSizeChange(c);
                }}
              >
                <div style={{ textAlign: "end" }}>{Math.floor(c)}</div>
                <div
                  style={{
                    width: 100,
                    height: c,
                    maxHeight: 13,
                    background: "#333333",
                  }}
                />
              </Icon>
            ))}
          </div>
        </ClickAway>
      </div>

      <Icon
        style={{ padding: "0 10px", marginLeft: 20 }}
        bg={"#e5e5e5"}
        onClick={() => {
          const images = [];
          const canvas = window?.pdfDoc?.querySelectorAll(`canvas`);
          for (let c of canvas) {
            images.push(c.toDataURL());
          }
          props.onImageChange(images);
        }}
      >
        Save
      </Icon>
    </div>
  );
}

function pageNumberValidation(pageNo, limit, defaultValue) {
  if (!inputValidation(pageNo, "int") || +pageNo > +limit || +pageNo < 1) {
    return defaultValue;
  }
  return parseInt(pageNo);
}

function PageInputBox(props) {
  const inputRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(props.currentPage + 1);

  useEffect(() => setCurrentPage(props.currentPage + 1), [props.currentPage]);

  function handleChange(e) {
    e.preventDefault();
    setCurrentPage(e.target.value);
  }

  function handlePageNav(e) {
    if (e.keyCode !== 13) {
      return;
    }

    const currentPage_ = pageNumberValidation(+currentPage, props.totalPage, props.currentPage + 1);
    setCurrentPage(currentPage_);

    const currentPageNode = window?.pdfDoc?.querySelector?.(`.pdf-sheet[dataindex="${currentPage_ - 1}"]`);

    currentPageNode.scrollIntoView();
    inputRef.current.blur();
  }

  function scrollHandler(e) {
    inputRef.current.blur();
  }
  function handleButtonClick(direction) {
    let newPage = currentPage;
    if (direction === "up") {
      newPage = Math.min(currentPage + 1, props.totalPage);
    } else if (direction === "down") {
      newPage = Math.max(currentPage - 1, 1);
    }
    setCurrentPage(newPage);

    const currentPageNode = window?.pdfDoc?.querySelector?.(`.pdf-sheet[dataindex="${newPage - 1}"]`);
    currentPageNode.scrollIntoView();
  }

  function scrollHandler(e) {
    inputRef.current.blur();
  }

  useEffect(() => {
    const scrollCont = window?.pdfDoc?.getElementById("pdf-sheet--cont");
    scrollCont?.addEventListener?.("scroll", scrollHandler);

    return () => scrollCont?.removeEventListener?.("scroll", scrollHandler);
  }, []);


  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
        <input
          ref={inputRef}
          type="text"
          style={{
            width: "50px",
            height:"35px",
            textAlign: "center",
            paddingRight: "20px", 
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
          value={currentPage}
          onChange={handleChange}
          onKeyDown={handlePageNav}
        />
        <div
          style={{
            position: "absolute",
            right: "2px",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => handleButtonClick("up")}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "2px",
              fontSize: "12px",
              lineHeight: 1,
            }}
          >
            ▲
          </button>
          <button
            onClick={() => handleButtonClick("down")}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "2px",
              fontSize: "12px",
              lineHeight: 1,
            }}
          >
            ▼
          </button>
        </div>
      </div>
      <div style={{ marginLeft: "10px" }}> of {props.totalPage}</div>
    </div>
  );
}

function Toolbar(props) {
  const modalRef = useRef(null);
  const document = window?.pdfDoc || window.document;
  const lang = store.get("lang") || [];

  const [openModal, setOpenModal] = useState(false);
  const [fitWith, setFitWith] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const [showKeyboard, setShowKeyboard] = useState(false);
  const [selectedLang, setSelectedLang] = useState(null);
  const [showLangList, setShowLangList] = useState(false);
  // const { userData } = useContext(GlobalContext);
  const userData = { userID: 6, user_agency_id: 1 };

  // const fileType = props?.metaData?.name?.split(".")?.at(-1);
  const fileType = props.metaData.file_type ;
  async function handleDownload() {
    store.update("filename", "");
    setOpenModal(true);
  }

  function handleToggleFullScreen() {
    if (!document?.fullscreenElement) {
      document?.documentElement?.requestFullscreen?.();
      setIsFullScreen(true);
    } else if (document?.exitFullscreen) {
      document?.exitFullscreen?.();
      setIsFullScreen(false);
    }
  }

  function syncFullScreenStateUpdate(e) {
    setIsFullScreen(!!window?.pdfDoc?.fullscreenElement);
  }

  async function handleSaveDocument() {
    const jsonData = await idb.fetch(props.docId);
    if (!jsonData || !userData || !Object.keys(userData).length) return;

    const changedParagraphStack = ((await idb.fingerprints.getAllFromIndex(props.docId, "mutated", 1)) || []).map((d) => ({
      source_text: d.sourceText,
      translated_text: d.originalText,
      edited_text: d.text,
      id: d.id,
      page_id: d.pageid,
      action: d.action !== "none" ? d.action || "changed" : "changed",
    }));

    const changedPageStack = ((await idb.assets.getAllFromIndex(props.docId, "mutated", 1)) || []).map((d) => ({
      page_id: d.pageid,
      pageindex: d.pageindex,
      action: d.action === "none" ? "changed" : d.action || "changed",
    }));

    const payload = {
      document_id: props.docId,
      user_id: userData.userID,
      organisation_id: userData.user_agency_id,
      json_file: jsonData,
      modified_data: {
        paragraph: changedParagraphStack,
        page: changedPageStack,
      },
    };

    const api = new API();
    const result = await api.call({ cmd: "saveJSONData", payload });
    idb.metadata.put(props.docId, { lastactiontime: moment().unix() }, "metadata");

    for (let s of changedParagraphStack) {
      const action = s.action === "inserted" ? "changed" : s.action || null;
      idb.fingerprints.put(props.docId, { mutated: 0, action }, s.id);
    }
    for (let s of changedPageStack) {
      const action = s.action === "inserted" ? "changed" : s.action || null;
      idb.assets.put(props.docId, { mutated: 0, action }, s.page_id);
    }
  }

  function handleLangSelect(selectedLang) {
    setSelectedLang(selectedLang);
    setShowLangList(false);

    props?.onSelectLang?.(selectedLang);
  }

  useEffect(() => {
    document.addEventListener("fullscreenchange", syncFullScreenStateUpdate);
    return () => document.removeEventListener("fullscreeenchange", syncFullScreenStateUpdate);
  }, []);

  async function modalSubmit(type) {
    const filename = store.get("filename") || "";
    if (!filename) return;

    modalRef.onHandle(async () => {
      let context = {};
      switch (type) {
        case "txt": {
          context.endpoint = "totxt";
          context.body = { data: await idb.reSyncFrom(props.docId) };
          break;
        }

        case "pdf": {
          context.endpoint = "topdf";
          context.body = { html: getHTML(), metaData: { ...props.metaData } };
          break;
        }
        default:
          return;
      }
      const result = await trackPromise(
        fetch(`https://languageapi.krtrimaiq.ai:6012/${context.endpoint}`, {
          headers: { "Content-Type": "application/json" },
          method: "POST",
          body: JSON.stringify({ ...context.body }),
        }),
        "download-pdf"
      );

      const data = await result.arrayBuffer();
      const url = URL.createObjectURL(new Blob([data]));
      saveAs(url, filename + "." + type);
      console.log("executed", data);
    });
  }

  return (
    <React.Fragment>
      <div className="pdf-toolbar--cont">
        <div className="flex-row gap-[26px] small-screen-hide">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 11.26,
            }}
          >
            <strong style={{marginTop:10}}>{props.metaData.name}</strong>

            <div
              style={{
                marginLeft: 20,
                marginTop:10,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              {fileType === "pdf" && (
                <Icon
                  title="Image Mode"
                  style={{ cursor: "default", userSelect: "none" }}
                  active={props.isImageMode}
                  onClick={props.onImageModeClick}
                  disabled={props.readOnly}
                >
                  <RxImage />
                </Icon>
             )}

              {!!props.isImageMode && (
                <ImageEditToolbar
                  _key={props._key}
                  brush={props.brush}
                  onColorSelect={props.onColorSelect}
                  onBrushSelect={props.onBrushSelect}
                  onBrushSizeChange={props.onBrushSizeChange}
                  onImageChange={props.onImageChange}
                />
              )}
            </div>
          </div>
        </div>

        <div
          className="flex-row flex justify-start lg:justify-center"
          style={{
            flexGrow: 1,
            gap: 16,
            // justifyContent: "start",
            // position: "absolute",
            // left: "calc(50% - 6px)",
            // transform: "translateX(-50%)",
          }}
        >
          <PageInputBox totalPage={props.totalPage} currentPage={props.currentPage} />
        </div>
        <div style={{ flexGrow: 1 }}>
          <Scale scaleOptions={scaleOptions} value={props.scaleValue} onChange={props.onScaleChange} />
        </div>

        <div className="flex-row">
          {!props.readOnly && (
            <div className="tooltipbar--drop-select--main-cont mr-[80px] max-sm:mr-[20px]">
              <ClickAway onClickAway={setShowLangList} sync={showLangList}>
                <div
                  id="lang"
                  className="tooltipbar--drop-select-cont"
                  onClick={() => {
                    setShowKeyboard(!showKeyboard);
                    props.onShowKeyboard(!showKeyboard);
                  }}
                >
                  {/* <label htmlFor="lang">{selectedLang?.name}</label> */}
                  {/* <div className="tooltipbar--drop-select" active={showKeyboard.toString()}>
                    <RxKeyboard />
                  </div>

                  <div
                    className="flex-row"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowLangList(!showLangList);
                    }}
                  >
                    <RxCaretDown />
                  </div> */}
                </div>
                <div
                  className="color-picker--cont"
                  style={{
                    display: showLangList ? "flex" : "none",
                    flexDirection: "column",
                    gap: 2,
                    padding: 2.6,
                    background: "#f7f7f7",
                    overflowY: "auto", // Allows vertical scrolling
                    maxHeight: "190px" // Adjust based on your needs
                  }}
                  
                >
                  {lang.map((c, idx) => (
                    <Icon
                      key={idx}
                      active={selectedLang === c}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: 2.6,
                        width: 126,
                      }}
                      onClick={() => handleLangSelect(c)}
                    >
                      <div style={{ textAlign: "end" }}>{c.label}</div>
                    </Icon>
                  ))}
                </div>
              </ClickAway>
            </div>
          )}

          {!props.readOnly && (
            <Icon style={{ color: "#0078d4" }} onClick={handleSaveDocument}>
              Save
            </Icon>
          )}

<button className="pdf--icon" onClick={handleDownload}>
  <RxDownload />
</button>


          <Icon className="pdf--icon" onClick={handleToggleFullScreen}>
            {!isFullScreen ? <MdOpenInFull /> : <MdCloseFullscreen />}
          </Icon>

          <Icon className="pdf--icon" onClick={props?.onClose}>
            <RxCross1 />
          </Icon>
        </div>
      </div>

      <ModalApp
        ref={modalRef}
        open={openModal}
        onClose={setOpenModal}
        title="Download As"
        style={{ height: "auto", width: "auto" }}
        pos={{ y: -130 }}
        body={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              padding: "16px",
            }}
          >
            <input
              type="text"
              autoFocus
              className="page-input-box--cont"
              placeholder="Filename"
              onBlur={(e) => e.target.focus()}
              onChange={(e) => store.update("filename", e?.target?.value?.trim?.())}
              style={{ width: "100%", textAlign: "left", padding: 8 }}
            />
          </div>
        }
        footer={
          <div style={{ display: "flex" }}>
            <button
              style={{
                padding: "16px 26px",
                margin: "16px",
                color: "#fff",
                background: "#324357",
              }}
              onClick={() => modalSubmit("txt")}
            >
              <RxDownload /> &nbsp; &nbsp; .txt
            </button>

            <button
              style={{
                padding: "16px 26px",
                margin: "16px",
                color: "#fff",
                background: "#043b65",
              }}
              onClick={() => modalSubmit("pdf")}
            >
              <RxDownload /> &nbsp; &nbsp; .pdf
            </button>
          </div>
        }
      />
    </React.Fragment>
  );
}

export default Toolbar;

const Scale = (props) => {
  const [selectedIdx, setSelectedIdx] = useState(props.value ?? 3);

  function handleChange(offset = 0) {
    const idx = selectedIdx + offset < 0 ? 0 : Math.min(selectedIdx + offset, scaleOptions.length - 1);
    setSelectedIdx(idx);
    // eventBus.dispatch("selectscale", scaleOptions[idx].value);
    props.onChange(scaleOptions[idx].value);
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #f8f8f8",
        borderRadius: 5,
      }}
    >
      <button className="toolbarButton" onClick={() => handleChange(1)} disabled={selectedIdx === scaleOptions.length - 1}>
        <img src={zoomInIcon} alt="zoomin" />
      </button>
      <div style={{ background: "#f8f8f8", padding: "2px 8px" }}>{scaleOptions[selectedIdx].label}</div>
      <button className="toolbarButton" onClick={() => handleChange(-1)} disabled={selectedIdx === 0}>
        <img src={zoomOutIcon} alt="zoomout" />
      </button>
    </div>
  );
};
